import {
   Thread as GqlThreadType,
   ThreadMessage
} from '@flowwai-frontend/bps-officer-web/graphql'
import {
   Message,
   MessageType,
   SYSTEM_MESSAGE_SENDER_ID,
   Thread
} from '@flowwai-frontend/shared-web/ai-chat-support/data-access'

export const convertGqlThreadTypeToLocalThreadType = (
   gqlData: GqlThreadType
): Thread => ({
   threadId: gqlData.threadId,
   name: gqlData.name,
   messages: []
})

export const getMessageTypeFromMessageSenderId = (
   senderId: string
): MessageType => {
   const isSystemMessage = senderId === SYSTEM_MESSAGE_SENDER_ID

   return isSystemMessage ? 'REPLY' : 'QUESTION'
}

export const convertGqlMessageTypeToLocalMessageType = (
   gqlMessage: ThreadMessage
): Message => ({
   messageId: gqlMessage.messageId,
   content: gqlMessage.content,
   type: getMessageTypeFromMessageSenderId(gqlMessage.senderId),
   timeStamp: new Date(`${gqlMessage.date}T${gqlMessage.timestamp}`)
})
